import React                                from 'react';
import {render, unmountComponentAtNode}     from 'react-dom';
import Cams                                 from './../components/Cams/Cams';
import PjaxWrapper                          from '../utils/PjaxWrapper';

function run(
	containerId
) {

	const container = document.getElementById(containerId);

	if (container) {
		render(
			<Cams />,
			container
		);
	}

	PjaxWrapper.addUnloadFunc(() => {
		unmountComponentAtNode(container);
        // fallback on leaving page
        window.history.replaceState({pjax: true, url: window.location.href}, document.title, window.location.href);
	});
}

export {run};
